module.exports = __webpack_public_path__ + "img/remove.4cfcc9a8.svg";